import styled from "styled-components";

export const FollowUpCommentText = styled.span`
  color: #0000008c;
  margin-top: 16px;
  font-size: 16px;
  white-space: pre-line;
`;